/**
 * UTM tagging primitives for outbound links from the witn docs site.
 *
 * Pure-runtime model: the click-time interceptor in
 * `src/layouts/UtmCapture/UtmCapture.tsx` walks every <a href> at click time
 * and stamps the UTM payload onto anchors pointing to WITN_HOSTNAMES before
 * the browser navigates.
 *
 * Schema:
 *   utm_source  = "witn"               (constant)
 *   utm_medium  = "docs"               (default "docs")
 *   utm_content = data-utm-content attribute or utm--<value> className
 *   utm_campaign = inbound visitor campaign from last_touch
 *   utm_term     = inbound visitor term from last_touch
 *   ref_page    = window.location.pathname at click time
 */

/**
 * The witn browser-clickable hosts. Single source of truth for any code
 * building an outbound link.
 */
export const WITN_HOSTS_BY_NAME = {
  /** Marketing site. */
  WWW: 'https://www.thewitn.com',
  /** App dashboard / sign-up. */
  APP: 'https://app.thewitn.com',
  /** Marketing root (no `www.` prefix). */
  ROOT: 'https://thewitn.com',
} as const

/** Hostname-only set used by runtime guards (URL#hostname comparison). */
export const WITN_HOSTNAMES: ReadonlySet<string> = new Set(
  Object.values(WITN_HOSTS_BY_NAME).map((u) => new URL(u).hostname),
)

export type UtmMedium = 'docs'
